import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await register(name, email, password);
    setLoading(false);
    if (res.ok) navigate("/dashboard");
    else setError(res.error);
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 py-12" data-testid="register-page">
      <div className="w-full max-w-md border border-zinc-900 bg-white shadow-[8px_8px_0px_0px_rgba(10,10,10,1)] p-8">
        <img
          src="/brandbloom-logo.png"
          alt="Brand Bloom"
          className="h-14 w-auto object-contain mx-auto mb-6"
          data-testid="register-logo"
        />
        <span className="font-mono text-xs uppercase tracking-[0.2em] text-primary">Get started</span>
        <h1 className="mt-2 font-display font-black text-3xl tracking-tighter">Create account</h1>
        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <Label className="font-mono text-xs uppercase tracking-widest">Full name</Label>
            <Input
              required
              data-testid="register-name-input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="mt-2 rounded-none border-zinc-300 focus-visible:ring-primary"
              placeholder="Jane Doe"
            />
          </div>
          <div>
            <Label className="font-mono text-xs uppercase tracking-widest">Email</Label>
            <Input
              type="email"
              required
              data-testid="register-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 rounded-none border-zinc-300 focus-visible:ring-primary"
              placeholder="you@company.com"
            />
          </div>
          <div>
            <Label className="font-mono text-xs uppercase tracking-widest">Password</Label>
            <Input
              type="password"
              required
              minLength={6}
              data-testid="register-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 rounded-none border-zinc-300 focus-visible:ring-primary"
              placeholder="At least 6 characters"
            />
          </div>
          {error && (
            <p data-testid="register-error" className="text-sm text-destructive font-medium">
              {error}
            </p>
          )}
          <Button
            type="submit"
            disabled={loading}
            data-testid="register-submit-btn"
            className="w-full rounded-none bg-primary hover:bg-[#5E1F92] text-white font-mono uppercase tracking-widest h-11"
          >
            {loading ? "Creating…" : "Create Account"}
          </Button>
        </form>
        <p className="mt-6 text-sm text-zinc-600">
          Already have an account?{" "}
          <Link to="/login" data-testid="register-to-login" className="text-primary font-semibold hover:underline">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
